/**
 * 套餐相关常量和枚举
 */

/**
 * 套餐类型枚举
 */
export enum PlanTypeEnum {
  Sim = 'sim',
  Data = 'data',
}

/**
 * 套餐类型映射表
 * 用于在UI中显示套餐类型文本
 */
/** 与后端 package_type（小写 sim / data）对应的全平台展示文案 */
export const PLAN_TYPE_MAP: Record<string, string> = {
  [PlanTypeEnum.Sim]: 'SIM',
  [PlanTypeEnum.Data]: 'Data',
};

/**
 * 套餐类型选项（用于 ProTable valueEnum，查询仍传小写 value）
 */
export const PACKAGE_TYPE_VALUE_ENUM = {
  sim: { text: 'SIM' },
  data: { text: 'Data' },
};

/**
 * 套餐状态枚举
 */
export enum PlanStatusEnum {
  Pending = 'pending', // 待激活
  Activated = 'activated', // 激活
  Used = 'used', // 已使用
  Expired = 'expired', // 过期
}

/**
 * 套餐状态映射表
 * 用于在UI中显示状态文本和颜色
 */
export const PLAN_STATUS_MAP: Record<
  PlanStatusEnum,
  { text: string; color: string }
> = {
  [PlanStatusEnum.Pending]: { text: '待激活', color: 'warning' },
  [PlanStatusEnum.Activated]: { text: '使用中', color: 'success' },
  [PlanStatusEnum.Used]: { text: '已用尽', color: 'success' },
  [PlanStatusEnum.Expired]: { text: '已过期', color: 'warning' },
};

/**
 * 套餐状态选项
 * 用于表单下拉框
 */
export const PLAN_STATUS_OPTIONS = [
  {
    label: PLAN_STATUS_MAP[PlanStatusEnum.Activated].text,
    value: PlanStatusEnum.Activated,
  },
  {
    label: PLAN_STATUS_MAP[PlanStatusEnum.Expired].text,
    value: PlanStatusEnum.Expired,
  },
  {
    label: PLAN_STATUS_MAP[PlanStatusEnum.Used].text,
    value: PlanStatusEnum.Used,
  },
];

/**
 * 套餐显示类型
 * 1: App, 2: Web, 4: VIP
 */
export type PackageDisplay = 1 | 2 | 4;

/**
 * 套餐显示类型映射表
 * 用于在UI中显示显示类型文本
 */
export const PACKAGE_DISPLAY_MAP: Record<PackageDisplay, string> = {
  1: 'App',
  2: 'Web',
  4: 'VIP',
};

/**
 * 套餐显示类型选项
 * 用于表单下拉框
 */
export const PACKAGE_DISPLAY_OPTIONS = [
  {
    label: PACKAGE_DISPLAY_MAP[1],
    value: 1,
  },
  {
    label: PACKAGE_DISPLAY_MAP[2],
    value: 2,
  },
  {
    label: PACKAGE_DISPLAY_MAP[4],
    value: 4,
  },
];
